'use client';

import '@fontsource-variable/figtree/index.css';
import '@fontsource-variable/source-code-pro/index.css';

import { ChakraProvider, type ChakraProviderProps } from '@chakra-ui/react/styled-system';

import BitkitToaster from '../components/BitkitToast/BitkitToaster';
import { ResponsiveProvider } from '../hooks';
import bitkitTheme from '../theme';

const Provider = (props: Omit<ChakraProviderProps, 'value'>) => {
  const { children, ...rest } = props;
  return (
    <ChakraProvider {...rest} value={bitkitTheme}>
      <ResponsiveProvider>
        {children}
        <BitkitToaster />
      </ResponsiveProvider>
    </ChakraProvider>
  );
};

export default Provider;
